var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "row" },
    [
      _setup.productToUnassign
        ? _c(
            "b-modal",
            {
              attrs: {
                title: "Product unassign",
                "modal-class": "vue-need-bootstrap",
                lazy: "",
                centered: "",
                "no-close-on-backdrop": "",
              },
              on: {
                ok: function ($event) {
                  return _setup.unassignProduct(_setup.productToUnassign)
                },
              },
              model: {
                value: _setup.showUnassignConfirmModal,
                callback: function ($$v) {
                  _setup.showUnassignConfirmModal = $$v
                },
                expression: "showUnassignConfirmModal",
              },
            },
            [
              _c("div", [
                _vm._v("\n            Do you want to unassign the product "),
                _c("b", [
                  _vm._v('"' + _vm._s(_setup.productToUnassign.title) + '"'),
                ]),
                _vm._v("?\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _vm._v("If you click "),
                _c("b", [_vm._v("OK")]),
                _vm._v(
                  " there's no oopsies, no refunds, no come backs! I warned you!"
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.step === "selectProduct"
        ? _c(
            "div",
            { staticClass: "col" },
            [
              !_setup.products || !_setup.products.length
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("b-spinner", {
                        staticClass: "my-2",
                        attrs: { variant: "primary" },
                      }),
                    ],
                    1
                  )
                : _c(_setup.ProductSelector, {
                    attrs: {
                      products: _setup.products,
                      "selected-products": _setup.selectedProducts,
                    },
                    on: {
                      "product-select": _setup.onProductSelected,
                      "product-unassign": _setup.onProductUnassignClick,
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.step === "selectFile" && _setup.selectedProduct
        ? _c(
            "div",
            { staticClass: "col" },
            [
              _c(_setup.VariantsConfigurator, {
                attrs: {
                  "pod-service": "printful",
                  "selected-product-id": _setup.selectedProduct.id,
                  "printful-files": _setup.printfulFiles,
                  store: _vm.store,
                  configurations:
                    _setup.templateProductConfiguration.configurations,
                },
                on: { "variants-selected": _setup.onVariantsSelected },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.step === "finalRevision" && _setup.selectedProduct
        ? _c(
            "div",
            { staticClass: "col" },
            [
              _c(_setup.RevisionStep, {
                attrs: {
                  "pod-service": "printful",
                  "product-title": _setup.selectedProduct.title,
                  "provider-variants": _setup.selectedProviderVariants,
                },
              }),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: { variant: "primary" },
                  on: { click: _setup.onSave },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }